var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn fb-btn btn-lg d-flex",on:{"click":function($event){return _vm.continueWithFB()}}},[_c('font-awesome-icon',{staticClass:"icon text-white fb-icon",attrs:{"icon":['fab', 'facebook-square']}}),_c('p',{staticClass:"fb-text"},[_vm._v(_vm._s(_vm.$t('continue-with-facebook')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }